<template>
  <div>
    <h2>Edit QA user</h2>

    <dl class="row text-nowrap">
      <dt class="col-sm-2">Id type</dt>
      <dd class="col-sm-10">{{this.idType | getQAUserIdTypeStr}}</dd>

      <dt class="col-sm-2">Id value</dt>
      <dd class="col-sm-10">{{this.idValue}}</dd>
    </dl>

    <loading-indicator v-if="isLoading"></loading-indicator>

    <form v-if="isDataLoaded" @submit.prevent="save">
      <div class="form-group">
        <label for="description">Description</label>
        <textarea
          v-model="description"
          id="description"
          class="form-control"
          rows="3"
          maxlength="128"
          required
        />
      </div>

      <b-button :to="{name: 'qa_users'}">Cancel</b-button>
      <b-button type="submit" variant="primary">Save</b-button>
    </form>
  </div>
</template>

<script>
import { HTTP } from '../http-common';
import notifier from '../notifier';
import LoadingIndicator from './LoadingIndicator.vue';

export default {
  name: 'QAUserEdit',

  components: {
    LoadingIndicator,
  },

  props: {
    idType: {
      type: Number,
      required: true,
    },
    idValue: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      isLoading: false,
      description: null,
    };
  },

  computed: {
    isDataLoaded() {
      return this.description !== null;
    },
  },

  created() {
    this.isLoading = true;

    const url = `/qa_user/${this.idType}/${this.idValue}`;
    HTTP.get(url)
    .then(response => {
      const qaUser = response.data.data;
      this.description = qaUser.description;
    })
    .catch(e => {
      notifier.showError(e.response.data);
    })
    .finally(() => {
      this.isLoading = false;
    });
  },

  methods: {
    save() {
      notifier.deleteSenderNotifications(this);

      const data = new FormData();
      data.append('id_type', this.idType);
      data.append('id_value', this.idValue);
      data.append('description', this.description);

      HTTP.post('/qa_user', data)
      .then(() => {
        notifier.showSuccessAfterTransition('Changes saved.');
        this.$router.push({name: 'qa_users'});
      })
      .catch(e => {
        notifier.showError(e.response.data, {sender: this});
      });
    },
  },
};
</script>
